import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  Getbranch():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Branch/Get`);
  }

  Deletebranch(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Branch/Delete?id=${id}`);
  }

  Createbranch(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Branch/Create`,data);
  }
  Updatebranch(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Branch/Update`,data)
  }

  getcurrentlocation():Promise<any>{
    return new Promise((resolve , reject) => {
      navigator.geolocation.getCurrentPosition(res => {
        resolve({lng : res.coords.longitude , lat:res.coords.latitude})
      })
    })
  }
}
